import React from 'react';
import { Card, Flex } from 'antd';
import { Typography } from 'components/common';
import { CARD_STYLES } from './constants';

interface IntegrationCardProps {
  integration: any;
  index: number;
}

const CAMEL_PASCAL_SPLIT_REGEX = /(?<=[a-z])(?=[A-Z])|(?<=[A-Z])(?=[A-Z][a-z])/;

const IntegrationCard: React.FC<IntegrationCardProps> = ({ integration, index }) => {
  if (integration.data?._empty) {
    return null;
  }

  return (
    <Card
      key={index}
      size="small"
      style={{
        ...CARD_STYLES,
        cursor: integration.onClick ? 'pointer' : 'default'
      }}
      bordered
      title={<Flex align="center" gap="5px">
        {integration.icon && <img src={integration.icon} alt="integration-icon" style={{ width: '24px', height: '24px' }} />}
        {integration.title || `Integration ${index + 1}`}
      </Flex>}
      onClick={integration.onClick ? () => integration.onClick() : undefined}
    >
      <div className="integration-details">
        {integration.data && Object.entries(integration.data).filter(([key]) => key !== "_cachedAt").map(([key, value]: [string, any], itemIdx: number) => {
          if (value === null || value === undefined || value === '') return null;

          return (
            <div key={itemIdx} style={{ marginBottom: '8px' }}>
              <Typography variant="small-heading-3">
                <strong>{key.split(CAMEL_PASCAL_SPLIT_REGEX).join(' ')}:</strong> {String(value)}
              </Typography>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default IntegrationCard;
